import _get from 'lodash/get';

import { FETCH_ISSUES, SUBMIT_ISSUE } from './issueCreation.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const defaultState = {
  issuesList: [],
  isFetching: false,
  issueCreated: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_ISSUES[FAILURE]: {
      return { ...state, isFetching: true, issuesList: [] };
    }
    case FETCH_ISSUES[SUCCESS]: {
      return { ...state, isFetching: false, issuesList: action.response.data };
    }
    case FETCH_ISSUES[FAILURE]: {
      return { ...state, isFetching: false, issuesList: [] };
    }
    case SUBMIT_ISSUE[REQUEST]: {
      return { ...state, issueCreated: false };
    }
    case SUBMIT_ISSUE[SUCCESS]: {
      return { ...state, issueCreated: true };
    }
    case SUBMIT_ISSUE[FAILURE]: {
      return { ...state, issueCreated: false };
    }
    default:
      return { ...state };
  }
}
